import type { ColDef } from 'ag-grid-community';
import { DateCellRenderer } from '@/components/ag-grid/DateCellRenderer';
import { DurationCellRenderer } from '@/components/ag-grid/DurationCellRenderer';
import { StatusCellRenderer } from '@/components/ag-grid/StatusCellRenderer';

/**
 * Column definitions for synchronization iterations grid
 */
const iterationsColDef = (): ColDef[] => {
  const colDef: ColDef[] = [
    {
      headerName: 'Tenant ID',
      field: 'tenantId',
      width: 120,
      pinned: 'left',
      filter: 'agTextColumnFilter',
      enableRowGroup: true,
    },
    {
      headerName: 'Success',
      field: 'success',
      width: 100,
      cellRenderer: StatusCellRenderer,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
        valueFormatter: (params: any) => params.value ? 'Success' : 'Failed',
      },
    },
    {
      headerName: 'Duration',
      field: 'totalMs',
      width: 120,
      type: 'numericColumn',
      cellRenderer: DurationCellRenderer,
      filter: 'agNumberColumnFilter',
      enableValue: true,
    },
    {
      headerName: 'Start Time',
      field: 'start',
      width: 180,
      cellRenderer: DateCellRenderer,
      filter: 'agDateColumnFilter',
      sort: 'desc', // Default sort by start time descending
    },
    {
      headerName: 'End Time',
      field: 'end',
      width: 180,
      cellRenderer: DateCellRenderer,
      filter: 'agDateColumnFilter',
    },
    {
      headerName: 'Entity',
      field: 'entity',
      width: 150,
      filter: 'agSetColumnFilter',
      enableRowGroup: true,
      enablePivot: true,
    },
    {
      headerName: 'Description',
      field: 'description',
      flex: 1,
      minWidth: 200,
      filter: 'agTextColumnFilter',
      tooltipField: 'description',
      cellRenderer: (params: any) => {
        if (!params.value) return '';
        // Truncate long descriptions
        const maxLength = 80;
        if (params.value.length <= maxLength) return params.value;
        return `${params.value.substring(0, maxLength)}...`;
      },
    },
    {
      headerName: 'Items Processed',
      field: 'itemsProcessed',
      width: 130,
      type: 'numericColumn',
      filter: 'agNumberColumnFilter',
      enableValue: true,
      cellRenderer: (params: any) => {
        if (params.value === null || params.value === undefined) return '0';
        return params.value.toLocaleString();
      },
    },
    {
      headerName: 'Error',
      field: 'error',
      width: 200,
      filter: 'agTextColumnFilter',
      tooltipField: 'error',
      cellStyle: (params: any) => {
        if (params.value) {
          return {
            color: '#d32f2f',
            fontSize: '0.875rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          };
        }
        return undefined;
      },
    },
  ];
  
  return colDef;
};

export default iterationsColDef;